if (!customElements.get('price-slider')) {
  customElements.define(
      'price-slider',
    class PriceSlider extends HTMLElement {
      constructor() {
        super();
        this.fromSlider = this.querySelector('#fromSlider');
        this.toSlider = this.querySelector('#toSlider');
        this.fromInput = this.parentElement.querySelector('price-range').querySelector('.field:first-of-type input');
        this.toInput = this.parentElement.querySelector('price-range').querySelector('.field:not(:first-of-type) input');
        this.fillSlider(this.fromSlider, this.toSlider, '#ECECEC', '#313131', this.toSlider);
        this.setToggleAccessible(this.toSlider);

        this.fromSlider.oninput = () => this.controlFromSlider(this.fromSlider, this.toSlider, this.fromInput);
        this.toSlider.oninput = () => this.controlToSlider(this.fromSlider, this.toSlider, this.toInput);
        this.fromInput.oninput = () => this.controlFromInput(this.fromSlider, this.fromInput, this.toInput, this.toSlider);
        this.toInput.oninput = () => this.controlToInput(this.toSlider, this.fromInput, this.toInput, this.toSlider);
      }

      controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = this.getParsed(fromInput, toInput);
        this.fillSlider(fromInput, toInput, '#ECECEC', '#313131', controlSlider);

        if (from > to) {
          (fromSlider.value) = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
          fromSlider.value = from;
        }
      }

      controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = this.getParsed(fromInput, toInput);
        this.fillSlider(fromInput, toInput, '#ECECEC', '#313131', controlSlider);
        this.setToggleAccessible(toInput);

        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toSlider.value = to;
          toInput.value = to;
        }
      }

      controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = this.getParsed(fromSlider, toSlider);
        this.fillSlider(fromSlider, toSlider, '#ECECEC', '#313131', toSlider);

        if (from > to) {
          fromSlider.value = to.replace(',', '.');
          fromInput.value = parseFloat(to).toFixed(2).replace('.', ',');
        } else {
          fromInput.value = parseFloat(from).toFixed(2).replace('.', ',');
        }
      }

      controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = this.getParsed(fromSlider, toSlider);
        this.fillSlider(fromSlider, toSlider, '#ECECEC', '#313131', toSlider);
        this.setToggleAccessible(toSlider);

        if (from <= to) {
          toSlider.value = to.replace(',', '.');
          toInput.value = parseFloat(to).toFixed(2).replace('.', ',');
        } else {
          toInput.value = parseFloat(from).toFixed(2).replace('.', ',');
          toSlider.value = from;
        }
      }

      getParsed(currentFrom, currentTo) {
        const from = currentFrom.value;
        const to = currentTo.value;
        return [from, to];
      }

      fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
          to right,
          ${ sliderColor } 0%,
          ${ sliderColor } ${ (fromPosition) / (rangeDistance) * 100 }%,
          ${ rangeColor } ${ ((fromPosition) / (rangeDistance)) * 100 }%,
          ${ rangeColor } ${ (toPosition) / (rangeDistance) * 100 }%,
          ${ sliderColor } ${ (toPosition) / (rangeDistance) * 100 }%,
          ${ sliderColor } 100%)`;
      }

      setToggleAccessible(currentTarget) {
        const toSlider = this.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }
    }
  );
}
